import { useEffect } from 'react'

interface useLoadFilterBarProps {
  isLoaded: string
  loadedCounter: number
  setLoadedCounter: Function
  filters: any
  setLoadedFilterCount: React.Dispatch<React.SetStateAction<number | null>>
  isLoadedFunc?: Function
}

const useLoadFilterBar = (props: useLoadFilterBarProps) => {

  useEffect(() => {
    if (props.isLoaded !== '') {
      props.setLoadedCounter((prev) => prev+ 1)
    }
  }, [props.isLoaded])
  
  useEffect(() => {
    if (props.loadedCounter > 0) {
      if (props.loadedCounter === props.filters.length) {
        props.setLoadedFilterCount(props.filters.length)
        props.isLoadedFunc && props.isLoadedFunc(true)
      }
    }
  }, [props.loadedCounter])
}

export default useLoadFilterBar
